export const styles = {
  modalContainer: {
    justifyContent: 'center',
    flexDirection: 'column',
    paddingTop: 20,
  },
  close: {
    position: 'absolute',
    top: 32,
    right: 8,
    cursor: 'pointer',
  },
  description: {
    fontSize: 16,
    fontWeight: '400',
    textAlign: 'center',
    fontFamily: "'Proxima Nova', sans-serif",
    marginBottom: 24,
    width: '100%',
    alignSelf: 'center',
  },
  modalTitle: {
    fontSize: 24,
    fontWeight: '700',
    textAlign: 'center',
    fontFamily: "'Proxima Nova', sans-serif",
    margin: '20px 0',
    width: '100%',
    alignSelf: 'center',
  },
  modalButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignSelf: 'center',
    marginBottom: 30,
  },
  modalDataWrapper: {
    height: 390,
    overflowY: 'scroll',
    margin: '0 -40px',
    padding: '0 40px',
    marginBottom: 30,
  },
  modalRow: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 16,
  },
  modalItemWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 16,
    width: '33%',
  },
  germanyPayrollItemWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '43%',
  },
  itemTitle: {
    color: '#707087',
    fontSize: 14,
    fontFamily: "'Proxima Nova', sans-serif",
    marginBottom: 10,
  },
  itemValue: {
    color: '#011533',
    fontSize: 16,
    fontFamily: "'Proxima Nova', sans-serif",
    marginBottom: 10,
    overflowWrap: 'anywhere',
  },
  divider: {
    backgroundColor: '#E2E2FC',
    width: '100%',
    height: 1,
    marginBottom: 16,
  },
  nmbrsDescription: {
    fontSize: 16,
    fontWeight: '400',
    textAlign: 'center',
    fontFamily: "'Proxima Nova', sans-serif",
    marginBottom: 24,
    width: '100%',
    alignSelf: 'center',
  },
  nmbrsModalTitle: {
    fontSize: 24,
    fontWeight: '700',
    textAlign: 'center',
    fontFamily: "'Proxima Nova', sans-serif",
    margin: '10px 0 30px 0',
    width: '100%',
    alignSelf: 'center',
  },
  rejectReasonInput: {
    padding: '4px',
    textAlign: 'left',
    width: '100%',
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: '14px',
    color: '#011533',
    height: '240px !important',
  },
  rejectReasonInputRoot: {
    padding: '4px',
    width: '100%',
    height: '250px',
    '& fieldset': {
      height: '240px',
    },
  },
  cancelButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 30,
  },
  counter: {
    fontSize: 12,
    color: '#526181',
    fontFamily: "'Proxima Nova', sans-serif",
    marginBottom: 32,
  },
  modalSectionTitle: {
    fontSize: 24,
    fontFamily: "'Proxima Nova', sans-serif",
    marginBottom: 24,
    fontWeight: '700',
    color: 'black',
    alignSelf: 'center',
  },
  modalSectionSubtitle: {
    fontSize: 18,
    fontFamily: "'Proxima Nova', sans-serif",
    marginBottom: 20,
    fontWeight: '700',
    color: 'black',
  },
}
